import InvestmentCompleted from './InvestmentCompleted'

export default InvestmentCompleted
